import Router from "next/router";

const redirect = ({ res }, location = "/") => {
  if (res) {
    res.writeHead(307, {
      Location: location,
    });

    res.end();
  } else {
    Router.replace(location);
  }
};

export default redirect;
